import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import SpecialTipCard from "./SpecialTipCard";
import arrowleft from "../../../assets/img/icons/arrow-left.svg";
import arrowright from "../../../assets/img/icons/arrow-right.png";
import Filterrow from "../../common/Filterrow";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="outlined-icon center  ml-[24px]" onClick={onClick}>
      <img src={arrowright} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="outlined-icon center" onClick={onClick}>
      {" "}<img src={arrowleft} />
    </div>
  );
}
const SpecialTipsCarousel = ({ infoHome }) => {
  const slider1 = useRef();
  const [filter, setFilter] = useState("all");

  useEffect(() => {}, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: '6%',
    className: "carousel-padding",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
      
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
      
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const next = () => {
    slider1.current.slickNext();
  };
  const previous = () => {
    slider1.current.slickPrev();
  };
  return (
    <div className="SpecialTipsCarousel">
      <div className="mb-[40px] flex justify-between  items-center">
        <Filterrow filter={filter} setFilter={setFilter} />
        <div className="flex">
          <SampleNextArrow onClick={next} />
          <SamplePrevArrow onClick={previous} />
        </div>
      </div>
      {infoHome
        ? <div>
            {filter === "all"
              ? (infoHome.residences_with_special_discount.length > 4 ?<Slider
                  ref={slider => (slider1.current = slider)}
                  {...settings}
                >
                  
                   {  infoHome.residences_with_special_discount.map(i =>
                        <SpecialTipCard info={i} key={i.id} />
                      )
                   }
                </Slider>
                 : <div className="grid md:grid-cols-4 grid-cols-2 gap[32px]">
                 {infoHome.residences_with_special_discount.map(i =>
                   <SpecialTipCard info={i} key={i.id} />
                 )}
               </div>)
              : filter === "popular"
                ? (infoHome.residences_with_special_discount_popular.length > 4 ? <Slider
                    ref={slider => (slider1.current = slider)}
                    {...settings}
                  >
                    {infoHome.residences_with_special_discount_popular.map(i =>
                      <SpecialTipCard info={i} key={i.id} />
                    )}
                  </Slider>:
                   <div className="grid  md:grid-cols-4 grid-cols-2 gap[32px]">
                   {infoHome.residences_with_special_discount_popular.map(i =>
                     <SpecialTipCard info={i} key={i.id} />
                   )}
                 </div>)
                : filter === "luxe"
                  ? (infoHome.residences_with_special_discount.length > 4 ?<Slider
                    ref={slider => (slider1.current = slider)}
                    {...settings}
                  >
                    
                     {  infoHome.residences_with_special_discount.map(i =>
                          <SpecialTipCard info={i} key={i.id} />
                        )
                     }
                  </Slider>
                   : <div className="grid  md:grid-cols-4 grid-cols-2 gap[32px]">
                   {infoHome.residences_with_special_discount.map(i =>
                     <SpecialTipCard info={i} key={i.id} />
                   )}
                 </div>)
                  : filter === "economy"
                    ? (infoHome.residences_with_special_discount.length > 4 ?<Slider
                      ref={slider => (slider1.current = slider)}
                      {...settings}
                    >
                      
                       {  infoHome.residences_with_special_discount.map(i =>
                            <SpecialTipCard info={i} key={i.id} />
                          )
                       }
                    </Slider>
                     : <div className="grid  md:grid-cols-4 grid-cols-2 gap[32px]">
                     {infoHome.residences_with_special_discount.map(i =>
                       <SpecialTipCard info={i} key={i.id} />
                     )}
                   </div>)
                    : null}
          </div>
        : <div className="container">
            <SkeletonTheme height={400} borderRadius={10}>
              <div className="grid  md:grid-cols-4 grid-cols-2 gap-[20px]">
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            </SkeletonTheme>
          </div>}
    </div>
  );
};

export default SpecialTipsCarousel;
